module.exports = __webpack_public_path__ + "static/media/pendencie-icon.4e1f0599.svg";